import { ReactElement, useCallback } from 'react'

import { ProductTypeToggleGroup } from '@features/products/elements/ProductTypeToggleGroup'
import { isInvoiceProductType } from '@features/products/utils/isInvoiceProductType'

import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { useUpdateDependentLineValues } from '../../../../../../../../../../hooks/useUpdateDependentLineValues'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

type InvoiceLineProductTypeProps = CommonInvoiceLineFieldProps

export const InvoiceLineProductType = ({ disabled = false, lineIndex }: InvoiceLineProductTypeProps): ReactElement => {
  const { handleProductTypeChange } = useUpdateDependentLineValues()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem } = invoiceEditorForm

  const handleToggleGroupChange = useCallback(
    (value?: string) => {
      if (isInvoiceProductType(value)) {
        trackInvoiceEditor('Form - Invoice lines - Item type selected', {
          option: value,
        })
      }
    },
    [trackInvoiceEditor],
  )

  return (
    <FormItem
      name={`invoiceLines.${lineIndex}.productType`}
      render={({ field: { onChange, value } }) => {
        return (
          <ProductTypeToggleGroup
            disabled={disabled}
            onChange={(event) => {
              onChange(event)
              handleToggleGroupChange(event?.target?.value)
              handleProductTypeChange(lineIndex, event?.target?.value)
            }}
            value={value}
          />
        )
      }}
    />
  )
}
